(() => {
  const init = () => {
    if (Alpine.store('xQuickView')) return;
    const config = window.xQuickView;
    if (!config) return;
    let pending;
    let args;
    let opening = false;
    let openFrom = '';
    let listen = false;
    const events = new AbortController();
    const ensure = () => {
      if (pending) return pending;
      pending = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = config.scriptUrl;
        script.onload = () => {
          const live = Alpine.store('xQuickView');
          if (!live || live.lazyRuntime) {
            script.remove();
            pending = null;
            reject(new Error('Quick view initialization failed'));
            return;
          }
          events.abort();
          if (listen) live.addListener();
          if (args) live.load(...args);
          if (opening) live.open(openFrom);
          resolve(live);
        };
        script.onerror = () => {
          script.remove();
          pending = null;
          reject(new Error('Quick view download failed'));
        };
        document.head.appendChild(script);
      });
      pending.catch(() => {
        if (args?.[1]) window.location.assign(args[1]);
      });
      return pending;
    };
    const stub = {
      lazyRuntime: true,
      enabled: config.enabled,
      buttonLabel: config.buttonLabel,
      show: false,
      loading: false,
      addListener() { listen = true; },
      focusQuickView() {},
      load(...values) { args = values; ensure(); return true; },
      open(from = '') { opening = true; openFrom = from; ensure(); },
      close() { opening = false; }
    };
    Alpine.store('xQuickView', stub);
    const options = { signal: events.signal };
    document.addEventListener('quickview:load', e => stub.load(e.detail.productId, e.detail.productUrl, e.detail.el), options);
    document.addEventListener('quickview:open', e => stub.open(e.detail?.openFrom), options);
    document.addEventListener('quickview:close', () => stub.close(), options);
    document.addEventListener('quickview:hide', () => stub.close(), options);
  };
  if (window.Alpine) init();
  else document.addEventListener('alpine:init', init, { once: true });
})();